import type { ReactNode } from 'react';

/** Placeholder for a value nobody has recorded. Reads as "unknown", never as zero. */
export function UnknownValue({ children = 'Unknown' }: { children?: ReactNode }) {
  return <span style={{ color: 'var(--nb-muted)', fontStyle: 'italic' }}>{children}</span>;
}
